import { createAction, createAsyncAction } from 'store/actionConfigs';
import type { Banner, Category, Salon, ShopInfo, StaffOption } from 'types/models';
import { PREFIX_ACTIONS } from './constants';

const init = createAction(PREFIX_ACTIONS + 'getInitShopData');
const initWithApiKey = createAction<string>(PREFIX_ACTIONS + 'getInitShopDataWithApiKey');
const initDone = createAction(PREFIX_ACTIONS + 'initDone');

const setShopLoading = createAction<boolean>(PREFIX_ACTIONS + 'shopLoading');

const data = {
  shopInfo: createAsyncAction<void, ShopInfo>(PREFIX_ACTIONS + 'shopInfo'),
  // fetch payload may be undefined: one call site passes Cookies.get() unguarded
  staffShopsByPhone: createAsyncAction<string | undefined, Salon[]>(PREFIX_ACTIONS + 'staffShopsByPhone'),
  staff: createAsyncAction<void, StaffOption[]>(PREFIX_ACTIONS + 'getStaffs'),
  staffAvailable: createAsyncAction<Record<string, unknown>, StaffOption[]>(PREFIX_ACTIONS + 'getStaffAvailable'),
  category: createAsyncAction<void, Category[]>(PREFIX_ACTIONS + 'category'),
  customer: createAsyncAction<any, any[]>(PREFIX_ACTIONS + 'customer'),
  allBanner: createAsyncAction<void, Banner[]>(PREFIX_ACTIONS + 'getAllBanner'),
};

const shopActions = {
  data,
  init,
  initDone,
  initWithApiKey,
  setShopLoading,
};

export default shopActions;

